<template>
  <div class="user-note-container">
    <!-- <div class="account-title">收支明细</div> -->
    <div class="table-bady user-note-table ">
      <table class="" cellpadding="0" cellspacing="0">
        <tr class="table-header">
          <td>
            <div>勾选</div>
          </td>
          <td><div>课程名称</div></td>
          <td><div>笔记条数</div></td>
          <td><div>最新笔记概要</div></td>
        </tr>
        <tbody>
          <tr class="table-tr" v-for="(item, index) in list" :key="index">
            <td class="text_align">
              <input
                type="checkbox"
                :checked="item.is_checked"
                @change="onCheckbox(item)"
              />
            </td>
            <td>
              <div class="text-hidden">{{ item.ke_title }}</div>
            </td>
            <td class="text_align">
              <div>{{ item.child_num }}</div>
            </td>
            <td>
              <div class="text-hidden">{{ item.child[0].msg }}</div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="pagination-box">
        <el-pagination
          layout="prev, pager, next"
          :current-page="query.page"
          :page-size="query.pageSize"
          :total="pageTotal"
          @current-change="handlePageChange"
        >
        </el-pagination>
      </div>
    </div>
    <div class="user-note-footer flex-row">
      <el-button type="primary" round @click="onCheckboxAll"
        >全{{ checkedAllStatus ? "不" : "" }}选</el-button
      >
      <el-button type="danger" round @click="onClose">退出</el-button>
      <el-button type="primary" round @click="down">导出已选</el-button>
    </div>
  </div>
</template>

<script>
import { export2Excel } from "../../config/common";
export default {
  name: "userNote",
  data() {
    return {
      query: {
        page: 1,
        pageSize: 6,
      },
      list: [],
      userMoney: {},
      pageTotal: 0,
      checkedNoteList: [],
      checkedAllStatus: false,
    };
  },
  created() {
    this.getUserNateList();
  },
  methods: {
    getUserNateList() {
      this.getRequest(
        "/wenjiaoopne/kc/user/course/note/getNoteList",
        this.query
      )
        .then((result) => {
          this.list = result.data.list;
          this.pageTotal = result.data.total_count;
        })
        .catch(() => {});
    },
    handlePageChange(v) {
      this.$set(this.query, "page", v);
      this.checkedAllStatus = false;
      this.getUserNateList();
    },
    onCheckbox(item) {
      this.$set(item, "is_checked", !item.is_checked);
    },
    onCheckboxAll() {
      this.checkedAllStatus = !this.checkedAllStatus;
      this.list.forEach((item) => {
        // this.$set(item, "is_checked", !item.is_checked);
        this.$set(item, "is_checked", this.checkedAllStatus);
      });
    },
    onClose() {
      this.$emit("closeCallBack", false);
    },
    down() {
      const tHeader = ["课程名称", "时间节点", "笔记内容"];
      const filterVal = ["ke_title", "date", "msg"];
      let lists = [];
      for (const iterator of this.list) {
        if (iterator.is_checked) {
          for (const item of iterator.child) {
            lists.push({
              ke_title: iterator.ke_title,
              date: item.times,
              msg: item.msg,
            });
          }
        }
      }
      if (lists.length == 0) {
        this.$message.error("请勾选要导出的笔记");
        return false;
      }
      export2Excel(tHeader, filterVal, lists, "笔记记录");
    },
    onLoading() {
      this.loading = this.$loading({
        lock: true,
        text: "Loading",
      });
    },
  },
};
</script>

<style scoped>
.user-note-table {
  position: relative;
  width: 830px;
  height: 400px;
  margin: 0 auto;
}
.user-note-table input[type="checkbox"]:after {
  background-color: #3ebee9;
}

.table-header {
  background-color: #3ebee9;
}

.user-note-table tr td {
  width: 255px;
}
.table-tr:hover {
  background-color: #f6f7fb !important;
}
.table-header td div {
  margin: 15px 0;
  padding: 2px 0;
  border-right: 1px solid #fff;
  text-align: center;
  font-size: 16px;
  color: #fff;
}
.table-bady {
  border: 1px solid #eaeefb;
}
.table-header td:last-child div {
  border-right: 0px;
}
.user-note-table tr td:first-child {
  width: 80px;
}
.table-tr {
  height: 50px;
}
.table-tr:nth-child(even) {
  background-color: #f1f0ef;
}
.user-note-footer {
  width: 930px;
  padding: 10px 0;
}
.pagination-box {
  position: absolute;
  bottom: 0;
  width: 830px;
  padding: 8px 0;
  text-align: center;
}
.flex-row {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}
.text_align {
  text-align: center;
}
.text-hidden {
  width: 250px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
